import { render, staticRenderFns } from "./pinpai.vue?vue&type=template&id=58e92c16&scoped=true"
import script from "./pinpai.vue?vue&type=script&lang=js"
export * from "./pinpai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e92c16",
  null
  
)

export default component.exports